import { PrimeIcons } from 'primereact/api';
import { MultiStateCheckbox } from 'primereact/multistatecheckbox';
import React, { useEffect, useState } from 'react';
import './NumericFilter.scss';
import { InputNumber } from 'primereact/inputnumber';

export interface NumericFilterValue {
  mode: string;
  value: number | null;
}

const options = [
  { value: 'equal', icon: 'pi pi-equals' },
  { value: 'greater-than', icon: PrimeIcons.CHEVRON_RIGHT },
  { value: 'less-than', icon: PrimeIcons.CHEVRON_LEFT },
];

interface Props {
  onChange?: (value: NumericFilterValue) => void;
  value: NumericFilterValue[] | undefined;
  placeholder?: string;
  isCurrency?: boolean;
  currencyLocale?: string;
  currencyCode?: string;
  inputId?: string;
}

export const NumericFilter = ({
  onChange,
  value,
  placeholder,
  isCurrency,
  currencyLocale = 'es-ES',
  currencyCode = 'EUR',
  inputId,
}: Props) => {
  const { mode = 'equal', value: filterValue = null } = value?.[0] ?? {};
  const [localValue, setLocalValue] = useState<number | null>(filterValue);
  const [localMode, setLocalMode] = useState<string>(mode);
  const [hadValue, setHadValue] = useState<boolean>(filterValue !== null);

  // Sincronizamos el valor local con el valor del prop
  useEffect(() => {
    setLocalValue(filterValue);
    setLocalMode(mode);
    setHadValue(filterValue !== null);
  }, [filterValue, mode]);

  const handleOnChange = (newMode: string, newValue: number | null, isValueChange: boolean) => {
    // Actualizamos el estado local
    setLocalMode(newMode);
    setLocalValue(newValue);

    if (newValue !== null && newValue !== undefined) {
      setHadValue(true);
      onChange?.({ mode: newMode, value: newValue });
    } else if (isValueChange && hadValue) {
      setHadValue(false);
      onChange?.(null as any);
    }
  };

  return (
    <div className='numeric-filter-container'>
      <MultiStateCheckbox
        value={localMode}
        onChange={(e) => handleOnChange(e.value, localValue, false)}
        options={options}
        empty={false}
        optionValue='value'
      />
      <InputNumber
        inputId={inputId}
        value={localValue}
        useGrouping={true}
        onChange={(e) => handleOnChange(localMode, e.value, true)}
        placeholder={placeholder}
        mode={isCurrency ? 'currency' : 'decimal'}
        currency={isCurrency ? currencyCode : undefined}
        locale={isCurrency ? currencyLocale : undefined}
        minFractionDigits={isCurrency ? 2 : 0}
        onBlur={() => {
          // Aseguramos que el valor se aplique correctamente al perder el foco
          if (localValue !== null) {
            handleOnChange(localMode, localValue, true);
          }
        }}
      />
    </div>
  );
};
